module.exports = __webpack_public_path__ + "static/media/BM_ManageProducts.b03e1437.svg";